import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { webApi, influencerApi } from '@/lib/api';
import { useNewInfluencerAuth } from '@/lib/config/apiFlags';

/**
 * 원본: .references/gc-mono/apps/gc-zoku/redux/modules/campaigns.js
 * 참여 가능한 캠페인 목록
 */

export interface Campaign {
  _id: string;
  campaignId: string;
  name: string;
  description?: string;
  imageUrl?: string;
  status?: string;
  typesOfAdvertising?: string[];
  socialMediaTypes?: string[];
  startDate?: string;
  endDate?: string;
  [key: string]: unknown;
}

interface CampaignsState {
  activeCampaigns: Campaign[] | null;
  loading: boolean;
}

const initialState: CampaignsState = {
  activeCampaigns: null,
  loading: false,
};

export const fetchCampaignsList = createAsyncThunk(
  'campaigns/list',
  async () => useNewInfluencerAuth()
    ? influencerApi.get<Campaign[]>('campaigns/list')
    : webApi.get<Campaign[]>('campaigns/list'),
);

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCampaignsList.fulfilled, (state, action) => {
        state.loading = false;
        state.activeCampaigns = action.payload;
      })
      .addCase(fetchCampaignsList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default campaignsSlice.reducer;
